<div class="input-group">
  <editable (modeChange)="openSelectForEdit($event)" [enabled]="!readonly">
    <ng-template leViewMode>
      <div class="form-control d-flex ng-select ng-select-clearable" [class.ng-select-multiple]="multiple" *ngLet="(multiple ? resourceId?.length : !!resourceId) as hasValue">
        <div class="ng-select-container ps-1" [class.ng-has-value]="hasValue">
          <div class="ng-value-container">
            <div class="ng-placeholder">{{placeholder}}</div>
            <div class="ng-value" *ngIf="(loading$ | async) && hasValue"><span class="ng-value-label text-muted">Loading...</span></div>
            <ng-container *ngIf="multiple; else single">
              <div class="ng-value me-1" *ngFor="let id of resourceId">
                <span class="ng-value-label">{{resourcesQuery.selectEntity(id) | async | displayName}}</span>
              </div>
            </ng-container>
            <ng-template #single>
              <div class="ng-value">
                <span class="ng-value-label">{{resourcesQuery.selectEntity(resourceId) | async | displayName}}</span>
              </div>
            </ng-template>
          </div>
        </div>
        <span class="ng-clear-wrapper ms-auto" [class.opacity-100]="hasValue" title="Clear all" *ngIf="hasValue && !readonly"
              (click)="$event.stopPropagation(); clearAll()">
          <span aria-hidden="true" class="ng-clear">×</span>
        </span>
      </div>
    </ng-template>
    <ng-template leEditMode>
      <ng-select #selectCmp
                 class="select-sm form-control"
                 bindLabel="DisplayName"
                 bindValue="Id"
                 appendTo="body" [placeholder]="placeholder"
                 [id]="name + '-id'"
                 [name]="name + '-name'"
                 [items]="filteredData$ | async"
                 [readonly]="readonly"
                 [class.readOnly]="readonly"
                 [searchFn]="searchFn"
                 [virtualScroll]="true" [addTag]="addTag" [addTagText]="addTagText" (focus)="focus.emit(selectCmp)"
                 [multiple]="multiple"
                 [(ngModel)]="resourceId"
                 (open)="onSelectOpen()"
                 (change)="select()">
      </ng-select>
    </ng-template>
  </editable>

  <button type="button" class="btn btn-sm btn-outline-primary" *ngIf="showEdit && resourceId" (click)="open()">
    <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
  </button>
  <button type="button" class="btn btn-sm btn-outline-primary" *ngIf="showSearch" (click)="openPicker(filterModal)" [disabled]="readonly">
    <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#magnifying-glass"></svg>
  </button>
  <ng-content></ng-content>
</div>

<ng-template #filterModal>
  <ng-container *transloco="let t; read: 'ime.manufacturing.resource'">
    <div class="modal-header p-2" ngxModalDraggable>
      <h4 class="modal-title">
        <div class="d-flex">
          <div class="wx-256">
            <input #globalSearch type="text" class="form-control" (input)="search$.next($event.target.value)" placeholder="Otsi koodi või nime järgi"/>
          </div>
          <button type="button" class="btn" aria-label="Close" (click)="globalSearch.value = ''">
            <span aria-hidden="true">Clear</span>
          </button>
        </div>
      </h4>
      <button type="button" class="btn-close ms-auto" aria-label="Close" (click)="pickerBsModalRef.close(); select()">
      </button>
    </div>
    <div class="modal-body p-2">
      <app-resource-table [stateKey]="null"
                          [filter]="filter" [selectionMode]="multiple ? 'multiple': 'single'" [selectedId]="resourceId"
                          [search$]="search$" (onSelect)="resourceId = $event;"></app-resource-table>
    </div>
  </ng-container>
</ng-template>
